// レコメンド配信（recommendation_distributions）。
// 既存レコメンドパーツ(widget)を中間表で束ね、A/Bテストはサブリソースとして内包する。
import type { ConversionAttribution } from '@/common/model/recommend/conversion'
import {
  ABCampaignGoalMetric,
  ABCampaignSegments,
  ABCampaignTargetDevice
} from '@/common/model/recommend/abCampaign'
import { WidgetContentType, WidgetDisplayLogic, WidgetLayoutType } from '@/common/model/recommend/widget'

export const RecommendationDistributionStatus = {
  DRAFT: 'draft', // 未配信
  RUNNING: 'running', // 配信中
  TESTING: 'testing', // A/Bテスト中
  ENDED: 'ended' // 配信終了
} as const

export type RecommendationDistributionStatus =
  (typeof RecommendationDistributionStatus)[keyof typeof RecommendationDistributionStatus]

// 配信に紐づくバリアント（= 表示パーツ + トラフィック配分）
export interface DistributionVariant {
  variant_label: string
  widget_id: number
  name: string
  display_logic: WidgetDisplayLogic
  title_template: string
  layout_type: WidgetLayoutType
  max_items: number
  custom_css: string
  content_type: WidgetContentType
  status: string
  ab_traffic: number
}

export interface DistributionAbCampaign {
  started_at: string | null
  completed_at: string | null
  winner_variant: string | null
  is_significant: boolean
}

export interface RecommendationDistribution {
  id: number
  site_id: number
  name: string
  code: string
  status: RecommendationDistributionStatus
  ab_enabled: boolean
  ab_variant_count: number
  goal_metric: ABCampaignGoalMetric
  // KPI目標がコンバージョン率のとき、A/B判定に使うコンバージョン種別
  cv_attribution: ConversionAttribution
  target_devices: ABCampaignTargetDevice[]
  target_segments: ABCampaignSegments[]
  min_sample_per_variant: number
  confidence_level: number
  distributes_at: string | null
  variants: DistributionVariant[]
  ab_campaign: DistributionAbCampaign | null
  created_at: string | null
  updated_at: string | null
}
